import { Expose } from 'class-transformer';

export default class TimeSheetChangeError {
  new_start_time: string[] = []
  new_end_time: string[] = []
  new_lunch_break: string[] = []
  comments: string[] = []
  created_by: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}